import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/utils/auth'

Vue.use(VueRouter)

const LayoutView = () => import('@/views/layout/index.vue')
const Login = () => import('@/views/login/index.vue')
const ProductList = () => import('@/views/product/index.vue')
const ProductAdd = () => import('@/views/product/add.vue')
const CategoryManage = () => import('@/views/category/index.vue')
const UserManage = () => import('@/views/user/index.vue')
const MiniUserManage = () => import('@/views/miniUser/index.vue')
const SettingsView = () => import('@/views/settings/index.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: LayoutView,
    redirect: '/product',
    children: [
      { path: 'product', name: 'ProductList', component: ProductList },
      { path: 'product/add', name: 'ProductAdd', component: ProductAdd },
      { path: 'product/edit/:id', name: 'ProductEdit', component: ProductAdd },
      { path: 'category', name: 'CategoryManage', component: CategoryManage },
      { path: 'user', name: 'UserManage', component: UserManage },
      { path: 'mini-user', name: 'MiniUserManage', component: MiniUserManage },
      { path: 'settings', name: 'SettingsView', component: SettingsView }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 登录守卫
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    // 已登录则跳转首页
    if (isLoggedIn()) {
      next('/product')
    } else {
      next()
    }
  } else {
    // 未登录则跳转登录页
    if (!isLoggedIn()) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
